import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import React, { useRef, useState } from "react";

export default function SearchInput() {
  const [expanded, setExpanded] = useState(false);
  const inputRef = useRef(null);

  const handleBlur = () => {
    // Collapse the input only if it's empty
    setTimeout(() => {
      if (inputRef.current && inputRef.current.value === "") {
        setExpanded(false);
      }
    }, 100); // Add a small delay to avoid collapsing too quickly
  };

  return (
    <div
      className={`relative flex items-center rounded-lg transition-[width] duration-500 ease-in-out ${
        expanded ? "w-64" : "w-12"
      }`}
      onMouseEnter={() => setExpanded(true)}
      onMouseLeave={() => {
        // Collapse only if the input is empty
        if (!inputRef.current.value) {
          setExpanded(false);
        }
      }}
    >
      {/* Input Field */}
      <Input
        type="text"
        ref={inputRef}
        placeholder="Search..."
        className={`bg-navbarBackground border-none focus:ring-0 p-1 flex-grow pr-10 ${
          expanded ? "block border" : "hidden"
        }`}
        onFocus={() => setExpanded(true)}
        onBlur={handleBlur} // Collapse if empty when losing focus
      />

      {/* Search Button (inside the input) */}
      <Button
        variant="ghost"
        size="icon"
        className="absolute h-auto right-1 top-1/2 transform -translate-y-1/2 rounded bg-muted"
      >
        <Search className="w-5 h-5 text-gray-400" />
      </Button>
    </div>
  );
}
